export enum TransactionErrorType {
  REJECTED_BY_USER,
  CALL_EXCEPTION,
  UNKNOWN,
  WARNING,
}

export type TransactionErrorWithMessage = {
  type: TransactionErrorType;
  internalLabel: string;
};

export interface SquidRouteError {
  message: string;
  statusCode: number;
  type: string;
}

export interface SquidStatusError {
  errorType?: string;
}

export type SquidRouteErrorType =
  | "Unknown"
  | "UnknownError"
  | "SquidServiceError"
  | "BAD_REQUEST";

export enum SquidStatusErrorType {
  NotFoundError = "NotFoundError",
}

export class QrCodeGenerationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "QrCodeGenerationError";
  }
}
